import {batch, signal} from "@preact/signals-react";

export const productPageImageDetailsIsEmpty = signal(false)
export const productPageImageDetailsHideMasterImages = signal(true)
export const productPageImageDetailsDataModal = signal(null)
export const productPageImageDetailsReportIssueData = signal({})

export const clearProductPageImageDetailSignal = () => batch(() => {
    productPageImageDetailsIsEmpty.value = false
    productPageImageDetailsHideMasterImages.value = true
    productPageImageDetailsDataModal.value = null
    productPageImageDetailsReportIssueData.value = {}
})